import { createMedia } from "@artsy/fresnel";

export const media = createMedia({
  breakpoints: {
    root: 0,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1560,
    xxl: 1920,
    desktop: 1024
  }
});

export const { Media, MediaContextProvider } = media;
export const mediaStyle = media.createMediaStyle(); // Generiert CSS